import { serverUrl, REQUIRED_ATTEMPTS_FALLBACK } from "@/config/default";
import { predict } from "@/functions/checker/predict";
import { dataWriter } from "@/functions/data";
import { selectTab } from "@/state/functions";
import { RootState } from "@/state/reducer";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Greeting = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const [auth, setAuth] = useState(false);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Прогресс прохождения теста
  const [completed, setCompleted] = useState(0);
  const [required, setRequired] = useState(REQUIRED_ATTEMPTS_FALLBACK);

  const startTest = () => {
    dataWriter.startMouseTracker();
    selectTab("step1");
  };

  useEffect(() => {
    Promise.all([
      predict("This is a meaningful sentence."),
      predict("Fiva fvaprvapr kjdngf kjrngrkvm."),
      predict("All your base are belong to us."),
    ]).then((res) => {
      console.log("Tests:", res, "expected:", [1, 0, 1]);
    });
  }, []);

  // Загрузка прогресса с сервера
  const loadProgress = async (token: string) => {
    try {
      const res = await fetch(`${serverUrl}progress`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) return;
      const data = await res.json();
      if (typeof data.completed === "number") setCompleted(data.completed);
      if (typeof data.required === "number") setRequired(data.required);
    } catch (err) {
      console.error(err);
    }
  };

  // Если токен уже сохранён — проверяем его и грузим прогресс
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${serverUrl}isauth`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => (res.ok ? res.json() : { error: "invalid" }))
      .then((data) => {
        if (!data.error) {
          setAuth(true);
          return loadProgress(token);
        }
        localStorage.removeItem("token");
      })
      .catch(() => localStorage.removeItem("token"));
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${serverUrl}auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login: login.trim(), password }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        setError(data.error || "Неверный логин или пароль");
        return;
      }

      localStorage.setItem("token", data.token);
      setAuth(true);
      await loadProgress(data.token);
    } catch (err) {
      console.error(err);
      setError("Ошибка соединения с сервером");
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setAuth(false);
    setLogin("");
    setPassword("");
    setCompleted(0);
  };

  const allDone = auth && completed >= required;

  return (
    <div className="page greeting gridCenter w100 h100">
      <div className="inner columnCenter gap24">
        <h1>Тест когнитивных способностей</h1>

        {!auth && (
          <form className="loginForm columnCenter gap12" onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Логин"
              autoComplete="username"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              disabled={loading}
            />
            <input
              type="password"
              placeholder="Пароль"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
            {error && <div className="loginError">{error}</div>}
            <button
              type="submit"
              className="btn mainBtn"
              disabled={loading || !login.trim() || !password}
            >
              {loading ? "Вход..." : "Войти"}
            </button>
          </form>
        )}

        {auth && (
          <>
            <div className="progress">
              Пройдено {completed} из {required}
            </div>

            {allDone ? (
              <div className="congrats columnCenter gap12">
                <h2>Поздравляем!</h2>
                <div>Вы прошли все {required} попыток. Спасибо за участие!</div>
              </div>
            ) : (
              <div className="btn mainBtn" onClick={startTest}>
                {completed > 0 ? "Пройти ещё раз" : "Начать тест"}
              </div>
            )}

            <div className="btn linkBtn" onClick={logout}>
              Выйти
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Greeting;
